import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  shape: {
    borderRadius: 12, // Material You roundedness
  },
  palette: {
    primary: {
      main: "#1E88E5", // Modern Material Blue
    },
    background: {
      default: "#f6f6f6",
      paper: "#ffffff",
    },
  },
  components: {
    MuiTouchRipple: {
      styleOverrides: {
        rippleVisible: {
          opacity: 0.15,
        },
        child: {
          backgroundColor: "rgba(30, 136, 229, 0.3)", // ripple color
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          "&:active": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        },
      },
    },
  },
});
